import { render, staticRenderFns } from "./event-modal.vue?vue&type=template&id=10f6fb19&scoped=true"
import script from "./event-modal.vue?vue&type=script&lang=ts"
export * from "./event-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f6fb19",
  null
  
)

export default component.exports